import React from 'react'
import PropTypes from 'prop-types'
import { Grid, TextField, Checkbox, FormControlLabel } from '@material-ui/core'
import Autocomplete from '@material-ui/lab/Autocomplete'
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank'
import CheckBoxIcon from '@material-ui/icons/CheckBox'

const blankIcon = <CheckBoxOutlineBlankIcon fontSize="small" />
const checkedIcon = <CheckBoxIcon fontSize="small" />

export const FormAnaliseConstatacao = (props) => {
  const { formAnaliseConstatacao, tiposSubstanciasQuimicas, tiposMetodologias, definitivo } = props

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Autocomplete
          value={formAnaliseConstatacao.formState.values.resultado}
          name="resultado"
          noOptionsText="Sem informações"
          options={['INDICATIVO', 'NÃO INDICATIVO']}
          onChange={(event, newValue) =>
            formAnaliseConstatacao.handleChangeNewValueByNameProperty(
              event,
              newValue,
              'resultado'
            )
          }
          getOptionLabel={(option) =>
            definitivo ? (option === 'INDICATIVO' ? 'POSITIVO' : 'NEGATIVO') : option
          }
          renderOption={(option) =>
            definitivo ? (option === 'INDICATIVO' ? 'POSITIVO' : 'NEGATIVO') : option
          }
          renderInput={(params) => (
            <TextField
              {...params}
              placeholder="Selecionar..."
              variant="outlined"
              label="RESULTADO DA ANÁLISE"
              required
              InputLabelProps={{
                shrink: true,
              }}
              error={formAnaliseConstatacao.hasError('resultado')}
              helperText={
                formAnaliseConstatacao.hasError('resultado')
                  ? formAnaliseConstatacao.formState.errors.resultado[0]
                  : null
              }
            />
          )}
        />
      </Grid>

      <Grid item xs={12}>
        <Autocomplete
          value={formAnaliseConstatacao.formState.values.subsQuims}
          name="subsQuims"
          multiple
          noOptionsText="Sem informações"
          options={tiposSubstanciasQuimicas}
          onChange={(event, newValue) =>
            formAnaliseConstatacao.handleChangeNewValueByNameProperty(
              event,
              newValue,
              'subsQuims'
            )
          }
          getOptionLabel={(option) => option.nome?.toUpperCase() || ''}
          renderOption={(option, { selected }) => (
            <>
              <Checkbox
                icon={blankIcon}
                checkedIcon={checkedIcon}
                style={{ marginRight: 8 }}
                checked={selected}
              />
              {option.nome?.toUpperCase()}
            </>
          )}
          renderInput={(params) => (
            <TextField
              {...params}
              placeholder={
                !formAnaliseConstatacao.formState.values.subsQuims?.length ? 'Selecionar...' : ''
              }
              variant="outlined"
              label="SUBSTÂNCIAS QUÍMICAS"
              required
              InputLabelProps={{
                shrink: true,
              }}
              error={formAnaliseConstatacao.hasError('subsQuims')}
              helperText={
                formAnaliseConstatacao.hasError('subsQuims')
                  ? formAnaliseConstatacao.formState.errors.subsQuims[0]
                  : null
              }
            />
          )}
        />
      </Grid>

      <Grid item xs={12}>
        <TextField
          label="OUTRO TIPO DE SUBSTÂNCIA"
          name="outroTipoSubstancia"
          variant="outlined"
          value={formAnaliseConstatacao.formState.values.outroTipoSubstancia}
          onChange={formAnaliseConstatacao.handleChange}
          disabled={
            !formAnaliseConstatacao.formState.values.subsQuims?.some(
              (substancia) => substancia.identificador === 'OUTRO'
            )
          }
          fullWidth
          InputLabelProps={{
            shrink: true,
          }}
        />
      </Grid>

      <Grid item xs={12}>
        <Autocomplete
          value={formAnaliseConstatacao.formState.values.metodConsts}
          name="metodConsts"
          multiple
          noOptionsText="Sem informações"
          options={tiposMetodologias}
          onChange={(event, newValue) =>
            formAnaliseConstatacao.handleChangeNewValueByNameProperty(
              event,
              newValue,
              'metodConsts'
            )
          }
          getOptionLabel={(option) => option.nome?.toUpperCase() || ''}
          renderOption={(option, { selected }) => (
            <>
              <Checkbox
                icon={blankIcon}
                checkedIcon={checkedIcon}
                style={{ marginRight: 8 }}
                checked={selected}
              />
              {option.nome?.toUpperCase()}
            </>
          )}
          renderInput={(params) => (
            <TextField
              {...params}
              placeholder={
                !formAnaliseConstatacao.formState.values.metodConsts?.length
                  ? 'Selecionar...'
                  : ''
              }
              variant="outlined"
              label="TESTE EMPREGADO"
              required
              InputLabelProps={{
                shrink: true,
              }}
              error={formAnaliseConstatacao.hasError('metodConsts')}
              helperText={
                formAnaliseConstatacao.hasError('metodConsts')
                  ? formAnaliseConstatacao.formState.errors.metodConsts[0]
                  : null
              }
            />
          )}
        />
      </Grid>

      <Grid item xs={12}>
        <FormControlLabel
          control={
            <Checkbox
              checked={!!formAnaliseConstatacao.formState.values.uso_proscrito_brasil}
              onChange={formAnaliseConstatacao.handleChange}
              name="uso_proscrito_brasil"
              color="primary"
            />
          }
          label="É de uso proscrito no Brasil de acordo com a Portaria 344/98-SVS/MS e atualizações posteriores"
        />
      </Grid>
    </Grid>
  )
}

FormAnaliseConstatacao.propTypes = {
  formAnaliseConstatacao: PropTypes.object.isRequired,
  tiposSubstanciasQuimicas: PropTypes.array.isRequired,
  tiposMetodologias: PropTypes.array.isRequired,
  definitivo: PropTypes.bool,
}
